var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2452 2.03928C12.5109 1.84096 14.7784 2.39935 16.6835 3.62475L15.5752 5.29982C14.0511 4.3195 12.2371 3.87279 10.4246 4.03145C8.61202 4.19011 6.90618 4.94493 5.58113 6.17464C4.25607 7.40435 3.38872 9.03755 3.11844 10.8118C2.84816 12.5861 3.19064 14.3985 4.09084 15.9578C4.99105 17.517 6.39673 18.7326 8.08203 19.4093C9.76732 20.086 11.6344 20.1844 13.3833 19.6888C15.1321 19.1932 16.6613 18.1323 17.725 16.6766C18.7887 15.2209 19.3253 13.4549 19.2484 11.6623L21.275 11.5778C21.3711 13.8186 20.7004 16.0261 19.3707 17.8457C18.0411 19.6654 16.1297 20.9915 13.9436 21.611C11.7575 22.2305 9.42364 22.1075 7.31702 21.2616C5.2104 20.4158 3.4533 18.8963 2.32804 16.9472C1.20278 14.9981 0.77469 12.7326 1.11254 10.5148C1.45039 8.29691 2.53458 6.25541 4.1909 4.71827C5.84722 3.18114 7.97951 2.23761 10.2452 2.03928ZM11.8442 15.2122L23.2539 3.96218L21.8497 2.53803L11.1421 13.0958L6.77315 8.78803L5.36894 10.2122L10.4399 15.2122L11.1421 15.9044L11.8442 15.2122Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplete);
export default __webpack_public_path__ + "static/media/complete.f8da642fb14e1a882f343178c216e239.svg";
export { ForwardRef as ReactComponent };